import { ApolloProvider, type NormalizedCacheObject } from "@apollo/client";
import { TooltipProvider } from "@appcaire/ui/components/ui/tooltip";
import { createRoot, hydrateRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./index.css";
import { getBrowserApolloClient, restoreApolloState } from "./lib/apollo";
import { initStockholmGa } from "./lib/analytics";
import { shouldHydrateRoot } from "./lib/hydration";

declare global {
  interface Window {
    __APOLLO_STATE__?: NormalizedCacheObject;
  }
}

const root = document.getElementById("root");
if (!root) throw new Error("Root element not found");

initStockholmGa();
restoreApolloState(window.__APOLLO_STATE__);
delete window.__APOLLO_STATE__;

const application = (
  <HelmetProvider>
    <ApolloProvider client={getBrowserApolloClient()}>
      <TooltipProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </TooltipProvider>
    </ApolloProvider>
  </HelmetProvider>
);

if (shouldHydrateRoot(root)) {
  hydrateRoot(root, application);
} else {
  createRoot(root).render(application);
}
